"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButtonStyles = exports.BreadcrumbLink = exports.DestructiveButtonLink = exports.IconButtonLink = exports.FlatButtonLink = exports.SecondaryButtonLink = exports.PrimaryButtonLink = exports.Link = exports.LinkStyles = exports.UnstyledLink = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var typeStyles_1 = require("../../Typography/typeStyles");
var theme_1 = require("../../theme");
var styles_1 = require("../Buttons/styles");
var focusRingStyles_1 = require("../focusRingStyles");
/** Re-export of React Aria's Link component without styling */
var react_aria_components_2 = require("react-aria-components");
Object.defineProperty(exports, "UnstyledLink", { enumerable: true, get: function () { return react_aria_components_2.Link; } });
var LinkStyles = function (_a) {
    var isMonochrome = _a.isMonochrome, color = _a.color, typeLevel = _a.typeLevel, fontWeight = _a.fontWeight;
    return (0, core_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: none;\n  width: fit-content;\n  outline: none;\n  border-radius: ", ";\n  cursor: pointer;\n\n  &[data-hovered] {\n    text-decoration: underline;\n  }\n\n  ", "\n  ", "\n\n  ", "\n"], ["\n  text-decoration: none;\n  width: fit-content;\n  outline: none;\n  border-radius: ", ";\n  cursor: pointer;\n\n  &[data-hovered] {\n    text-decoration: underline;\n  }\n\n  ", "\n  ", "\n\n  ", "\n"])), theme_1.theme.radii.rounded, focusRingStyles_1.FocusRingStyles, (0, typeStyles_1.getTypeStyles)(typeLevel, fontWeight, isMonochrome ? color : undefined), !isMonochrome && (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: ", ";\n\n    &[data-hovered] {\n      color: ", ";\n    }\n\n    &[data-pressed] {\n      color: ", ";\n    }\n\n    &[data-disabled] {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    font-weight: ", ";\n\n    &[data-hovered] {\n      color: ", ";\n    }\n\n    &[data-pressed] {\n      color: ", ";\n    }\n\n    &[data-disabled] {\n      color: ", ";\n    }\n  "])), theme_1.theme.colors.actionPrimary, theme_1.theme.fontWeights.medium, theme_1.theme.colors.actionPrimaryHovered, theme_1.theme.colors.actionPrimaryPressed, theme_1.theme.colors.n900));
};
exports.LinkStyles = LinkStyles;
/**
 * A styled link component that extends React Aria's Link component.
 * Provides default styling with hover, pressed, and disabled states.
 *
 * @example
 * ```tsx
 * <Link href="https://app.circleci.com">Link somewhere</Link>
 * ```
 *
 * @param href - The URL that the link points to
 * @param target - The target window or frame to open the link in
 * @param rel - The relationship between the current document and the linked document
 * @param isDisabled - Whether the link is disabled
 * @param color - The color of the link text (only used when isMonochrome is true)
 * @param typeLevel - The typography level (h1, h2, body, etc.)
 * @param fontWeight - The font weight (regular, medium, semiBold)
 * @param isMonochrome - When true, uses monochrome text styling; when false/undefined, uses link-specific actionPrimary color
 * @param className - Additional CSS classes to apply
 * @param onPress - Handler that is called when the link is pressed
 * @param onPressStart - Handler that is called when the link starts being pressed
 * @param onPressEnd - Handler that is called when the link stops being pressed
 * @param onPressChange - Handler that is called when the pressed state changes
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.Link = (0, styled_1.default)(react_aria_components_1.Link)(function (props) { return (0, exports.LinkStyles)(props); });
/**
 * A link styled as a primary button.
 * Extends React Aria's Link component with primary button styling.
 *
 * @example
 * ```tsx
 * <PrimaryButtonLink href="https://app.circleci.com">Primary</PrimaryButtonLink>
 * ```
 *
 * @param href - The URL that the link points to
 * @param target - The target window or frame to open the link in
 * @param rel - The relationship between the current document and the linked document
 * @param isDisabled - Whether the link is disabled
 * @param className - Additional CSS classes to apply
 * @param onPress - Handler that is called when the link is pressed
 * @param onPressStart - Handler that is called when the link starts being pressed
 * @param onPressEnd - Handler that is called when the link stops being pressed
 * @param onPressChange - Handler that is called when the pressed state changes
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.PrimaryButtonLink = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles_1.PrimaryButtonStyles);
/**
 * A link styled as a secondary button.
 * Extends React Aria's Link component with secondary button styling.
 *
 * @example
 * ```tsx
 * <SecondaryButtonLink href="https://app.circleci.com">Secondary</SecondaryButtonLink>
 * ```
 *
 * @param href - The URL that the link points to
 * @param target - The target window or frame to open the link in
 * @param rel - The relationship between the current document and the linked document
 * @param isDisabled - Whether the link is disabled
 * @param className - Additional CSS classes to apply
 * @param onPress - Handler that is called when the link is pressed
 * @param onPressStart - Handler that is called when the link starts being pressed
 * @param onPressEnd - Handler that is called when the link stops being pressed
 * @param onPressChange - Handler that is called when the pressed state changes
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.SecondaryButtonLink = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles_1.SecondaryButtonStyles);
/**
 * A link styled as a flat button.
 * Extends React Aria's Link component with flat button styling.
 *
 * @example
 * ```tsx
 * <FlatButtonLink href="https://app.circleci.com">Flat</FlatButtonLink>
 * <FlatButtonLink href="https://app.circleci.com" onDarkBackground>Flat on Dark</FlatButtonLink>
 * ```
 *
 * @param href - The URL that the link points to
 * @param target - The target window or frame to open the link in
 * @param rel - The relationship between the current document and the linked document
 * @param isDisabled - Whether the link is disabled
 * @param className - Additional CSS classes to apply
 * @param onPress - Handler that is called when the link is pressed
 * @param onPressStart - Handler that is called when the link starts being pressed
 * @param onPressEnd - Handler that is called when the link stops being pressed
 * @param onPressChange - Handler that is called when the pressed state changes
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param onDarkBackground - Whether the button is displayed on a dark background
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.FlatButtonLink = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles_1.FlatButtonStyles);
/**
 * A link styled as an icon button.
 * Extends React Aria's Link component with icon button styling.
 *
 * @example
 * ```tsx
 * <IconButtonLink href="https://app.circleci.com">
 *   <EditIcon />
 * </IconButtonLink>
 * <IconButtonLink href="https://app.circleci.com" size="small" onDarkBackground>
 *   <MoreHorizontalIcon />
 * </IconButtonLink>
 * ```
 *
 * @param href - The URL that the link points to
 * @param target - The target window or frame to open the link in
 * @param rel - The relationship between the current document and the linked document
 * @param isDisabled - Whether the link is disabled
 * @param className - Additional CSS classes to apply
 * @param onPress - Handler that is called when the link is pressed
 * @param onPressStart - Handler that is called when the link starts being pressed
 * @param onPressEnd - Handler that is called when the link stops being pressed
 * @param onPressChange - Handler that is called when the pressed state changes
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param onDarkBackground - Whether the button is displayed on a dark background
 * @param size - The size of the icon button
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.IconButtonLink = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles_1.IconButtonStyles);
/**
 * A link styled as a destructive button.
 * Extends React Aria's Link component with destructive button styling.
 *
 * @example
 * ```tsx
 * <DestructiveButtonLink href="https://app.circleci.com">Delete Item</DestructiveButtonLink>
 * ```
 *
 * @param href - The URL that the link points to
 * @param target - The target window or frame to open the link in
 * @param rel - The relationship between the current document and the linked document
 * @param isDisabled - Whether the link is disabled
 * @param className - Additional CSS classes to apply
 * @param onPress - Handler that is called when the link is pressed
 * @param onPressStart - Handler that is called when the link starts being pressed
 * @param onPressEnd - Handler that is called when the link stops being pressed
 * @param onPressChange - Handler that is called when the pressed state changes
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.DestructiveButtonLink = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles_1.DestructiveButtonStyles);
/**
 * A link styled for use in breadcrumb navigation.
 * Extends React Aria's Link component with breadcrumb-specific styling.
 *
 * @example
 * ```tsx
 * <BreadcrumbLink href="/path" data-current>Current Page</BreadcrumbLink>
 * ```
 *
 * @param href - The URL that the link points to
 * @param target - The target window or frame to open the link in
 * @param rel - The relationship between the current document and the linked document
 * @param isDisabled - Whether the link is disabled
 * @param className - Additional CSS classes to apply
 * @param onPress - Handler that is called when the link is pressed
 * @param onPressStart - Handler that is called when the link starts being pressed
 * @param onPressEnd - Handler that is called when the link stops being pressed
 * @param onPressChange - Handler that is called when the pressed state changes
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.BreadcrumbLink = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  font-size: ", ";\n  color: ", ";\n  outline: none;\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  border-radius: ", ";\n\n  &[data-hovered] {\n    text-decoration: underline;\n  }\n\n  &[data-current] {\n    color: ", ";\n    font-weight: ", ";\n    cursor: auto;\n  }\n\n  ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  font-size: ", ";\n  color: ", ";\n  outline: none;\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  border-radius: ", ";\n\n  &[data-hovered] {\n    text-decoration: underline;\n  }\n\n  &[data-current] {\n    color: ", ";\n    font-weight: ", ";\n    cursor: auto;\n  }\n\n  ", "\n"])), theme_1.theme.space.space4, theme_1.theme.fontSizes.fontsize16, theme_1.theme.colors.n600, theme_1.theme.radii.rounded, theme_1.theme.colors.n900, theme_1.theme.fontWeights.semiBold, focusRingStyles_1.FocusRingStyles);
/**
 * Link button styles that can be used with button components.
 * Provides link styling with button-like behavior.
 */
var LinkButtonStyles = function (props) { return (0, core_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  padding: 0;\n  ", "\n  cursor: default;\n  &[data-hovered] {\n    text-decoration: none;\n  }\n  &[data-pending] {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  background: none;\n  border: none;\n  padding: 0;\n  ", "\n  cursor: default;\n  &[data-hovered] {\n    text-decoration: none;\n  }\n  &[data-pending] {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n"])), (0, exports.LinkStyles)(props), theme_1.theme.opacity.semiOpaque); };
exports.LinkButtonStyles = LinkButtonStyles;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=index.js.map